module.exports = "/virtual-football-league/img/amblems/left/France/Fake_PSG.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/France/Fake_PSG.png
// module id = 2033
// module chunks = 4